<template>
  <div class="dropMark w100">
    <div class="flex-column h100 flex1">
      <div>
        <div class="block">
          <div class="inblock">
            时间:
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd hh:mm:ss"
            ></el-date-picker>
          </div>
          <div class="inblock ml10">
            <el-radio v-model="radio" label="1">未出厂</el-radio>
            <el-radio v-model="radio" label="2">已出厂</el-radio>
          </div>
        </div>
        <div class="block mt10">
          <div class="inblock">
            品牌:
            <el-input v-model="brand" placeholder="请输入内容"></el-input>
          </div>
          <div class="inblock ml10">
            名称:
            <el-input v-model="name" placeholder="请输入内容"></el-input>
          </div>
          <div class="inblock ml10">
            网格:
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="inblock ml10">
            颜色:
            <el-select v-model="color" placeholder="请选择">
              <el-option
                v-for="item in colorData"
                :key="item.color_name"
                :label="item.color_name"
                :value="item.color_name"
              ></el-option>
            </el-select>
          </div>
          <div class="inblock ml10">
            <el-button type="primary" @click="matchBid">开始匹配</el-button>
          </div>
        </div>
      </div>
      <div class="mt10 flex1 flex-column h100">
        <el-table
          :data="tableData"
          height="250"
          border
          style="width: 100%"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="shop_order_no" label="订单号" width="180"></el-table-column>
          <el-table-column prop="code_num" label="条形码" width="180"></el-table-column>
          <el-table-column prop="name" label="衣物名称"></el-table-column>
          <el-table-column prop="create_time" label="下单时间"></el-table-column>
          <el-table-column prop="color" label="颜色"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="cloth_wg" label="网格"></el-table-column>
          <el-table-column prop="appendix" label="附件"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 300,
      time: [],
      brand: '',
      name: '',
      color: '',
      radio: '1',
      currentPage4: 4,
      colorData: [],
      options: [{
        value: '请选择',
        label: '请选择'
      }, {
        value: '方格',
        label: '方格'
      }, {
        value: '花纹',
        label: '花纹'
      }, {
        value: '条纹',
        label: '条纹'
      }, {
        value: '卡通',
        label: '卡通'
      }, {
        value: '字母',
        label: '字母'
      }],
      value: '',
      tableData: []
    }
  },
  created() {
    this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D h:m:s')
    this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D h:m:s')
    this.matchBid()
    this.$http.getShopColor()
      .then(res => {
        this.colorData = [{ id: null, color_name: '请选择' }, ...res.data.data]
      })
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
    async matchBid() {
      let data = {
        outStatus: this.radio,
        startTime: this.time[0],
        endTime: this.time[1],
        color: this.color == '请选择' ? '' : this.color,
        brand: this.brand,
        name: this.name
      }
      let res = await this.$http.matchBid(data)
      this.tableData = res.data.data
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/view/dropMark.less";
</style>
<style lang="less">
.dropMark {
  .el-card__body {
    overflow-y: scroll;
  }
  .el-tabs__content {
    flex: 1;
    display: flex;
    .el-tab-pane {
      flex: 1;
      display: flex;
    }
  }
}
</style>